export const getAuthLoginLoading = state => state.authLoginLoading.loading;
